import React from 'react';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonOlList from '../../../common-components/common-ol-list';
import CommonSmallText from '../../../common-components/common-small-text';

const gensProcessList = {
    colorNumber: '#009bcc',
    list: [
        `Мы&nbsp;оказывали полную технологическую и&nbsp;информационную поддержку сайта. В&nbsp;пиковые нагрузки во&nbsp;время закрытия приема заявок команда работала 24/7. В&nbsp;2017 году за&nbsp;сутки до&nbsp;конца мы&nbsp;приняли более 1000&nbsp;заявок. Также мы&nbsp;самостоятельно наполняем календарь событий на&nbsp;сайте <a rel="noopener noreferrer nofollow" target="_blank" href="https://www.rvc.ru/" class="gens__link gens-process__link">rvc.ru</a>  с&nbsp;2016&nbsp;года. Находим мероприятия, адаптируем и&nbsp;публикуем.`,
        `Производили адаптацию открытой части сайта по&nbsp;ходу <a rel="noopener noreferrer nofollow" target="_blank"  href="https://generation-startup.ru/about/" class="gens__link gens-process__link">развития проекта</a>, начиная с&nbsp;2016 года и&nbsp;по&nbsp;настоящее время.`,
        `Реализовали платформу экспертизы для корпоративных стартапов с&nbsp;ролями: стартап, эксперт, представитель корпорации. Эта платформа состоит из&nbsp;нескольких блоков: личные кабинеты стартапов, экспертов, представителей корпораций, региональных партнеров и&nbsp;администраторов.`,
    ],
};

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="gens-process" smallPaddings={true}>
                <div className="gens-process__wrapper-up">
                    <CommonTitle className="gens-process__title">Процесс</CommonTitle>
                    <CommonOlList
                        className="gens-process__ol-list"
                        CommonOlList={gensProcessList}
                    />
                </div>
                <div className="gens-process__wrapper-down">
                    <img
                        className="gens-process__img"
                        src="/images/svg/gens/gens-process__img1.svg"
                        alt=""
                        loading="lazy"
                    />
                    <CommonSmallText className="gens-process__text">
                        Развернули экосистему внутри личных кабинетов, с&nbsp;помощью которой тысячи
                        инженерных команд со&nbsp;всей страны подавали заявки в&nbsp;десятки
                        акселераторов для крупнейших российских и&nbsp;мировых компаний, в&nbsp;том
                        числе Airbus, Michelin, Unilever, ВТБ и&nbsp;Enel. Для оценки заявок
                        стартапов независимыми экспертами мы&nbsp;создали кабинеты экспертов
                        по&nbsp;направлениям: бизнес и&nbsp;технологии. Также мы&nbsp;сделали
                        отдельный личный кабинет для представителей корпораций, где они могут
                        ознакомиться с&nbsp;результатами экспертизы, подробной информацией
                        по&nbsp;заявкам и&nbsp;статистикой трека.
                    </CommonSmallText>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
